<template>
  <div id="teacher-students">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container id="teachers-students-table">
      <b-row class="mt-4">
        <b-col class="md-5">
          <div class="table-wrap">
            <br />
            <b-col>
              <h4 class="subtitle">
                Teacher's Current Students ({{ studentsTable.length }})
              </h4>
              <b-form-group>
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-table
              v-cloak
              responsive
              :fields="teacherStudentsFields"
              :items="studentsTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(first_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditStudent',
                    params: { id: row.item.student_uuid },
                  }"
                >
                  {{ row.item.first_name }} {{ row.item.middle_name }}
                  {{ row.item.last_name }}
                </b-link>
              </template>
              <template slot="cell(sex)" slot-scope="row">{{
                row.item.sex === "male" ? "M" : "F"
              }}</template>
              <template slot="cell(active)" slot-scope="row">
                <b-form-radio-group
                  :id="row.item.uuid"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateTeacherStudent(row)"
                  v-if="isAdmin || isSRC"
                >
                  <b-form-radio :value="true">True</b-form-radio>
                  <b-form-radio :value="false">False</b-form-radio>
                </b-form-radio-group>
              </template>
               <template slot="cell(consent_given)" slot-scope="row">{{
                 row.item.consent_given == null  ? "N" : "Y"
              }}</template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  @click.stop="deleteTeacherStudent(row.item.id)"
                  v-if="isAdmin || isSRC"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col class="my-1 md-5">
                <b-pagination
                  :total-rows="studentsTable.length || 0"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col v-if="isAdmin || isSRC" class="md-5">
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Students</h4>
            <div>
              <name-search table="students"></name-search>
            </div>
            <br />
            <div v-if="cleanedSearchResults.length">
              <b-col>
                <h6 class="subtitle">
                  Results: {{ getStudentSearchResults.length }} students found
                </h6>
                <b-form-group>
                  <b-input-group>
                    <b-form-input
                      v-model="filterSearchResults"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-btn
                        :disabled="!filterSearchResults"
                        @click="filterSearchResults = ''"
                        >Clear</b-btn
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <div id="alerts" ref="teacher-students-alert">
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="success"
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                    >You have successfully added a student!</b-alert
                  >
                  <b-alert :show="showError" dismissible variant="warning">
                    Something went wrong. Please refresh and try again, or
                    contact the site admin.
                  </b-alert>
                </div>
              </b-col>
              <b-table
                v-cloak
                responsive
                :fields="searchResultsFields"
                :items="cleanedSearchResults"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filterSearchResults"
                @filtered="onFilteredResults"
              >
                <template slot="cell(first_name)" slot-scope="row">
                  <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditStudent', params: { id: row.item.uuid } }"
                    >{{ row.item.student_name }}</b-link
                  >
                  <br />
                  <p class="small-date">district: {{ row.item.district }}</p>
                  <p class="small-date">village: {{ row.item.village }}</p>
                </template>
                <template slot="cell(sex)" slot-scope="row">{{
                  row.item.sex === "male" ? "M" : "F"
                }}</template>
                <template slot="cell(id)" slot-scope="row">
                  <b-link class="add" @click.stop="addStudentToTeacher(row)"
                    >ADD</b-link
                  >
                </template>
              </b-table>
              <b-row>
                <b-col md="6" class="my-1">
                  <b-pagination
                    :total-rows="cleanedSearchResults.length || 0"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- <div v-else>Students are loading...</div> -->
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TeacherService from "../services/TeacherService";
import NameSearch from "@/components/NameSearch";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "TeacherStudents",
  mixins: [flash, scrollTo],
  components: {
    NameSearch,
  },
  data() {
    return {
      teacherId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      country: "",
      region: "",
      district: "",
      village: "",
      teacherStudentsFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: 'consent_given', label: 'Consent Given', sortable: true },
        { key: "delete", label: "DEL" },
      ],
      searchResultsFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "id", label: "ADD" },
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      perPage: 20,
      pageOptions: [10, 20, 50],
      filter: null,
      filterSearchResults: null,
      students: [],
    };
  },
  methods: {
    ...mapActions({
      GET_TEACHER_STUDENTS: "teachers/GET_TEACHER_STUDENTS",
      RESET_TEACHERS_STATE: "teachers/RESET_TEACHERS_STATE",
      SEARCH_STUDENTS: "searches/GET_STUDENTS_BY_LOCATION",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async searchStudents() {
      await this.SEARCH_STUDENTS();
    },
    async updateTeacherStudent(params) {
      const payload = await {
        id: params.item.id,
        student_uuid: params.item.student_uuid,
        teacher_uuid: this.$route.params.id,
        active: !params.item.active,
      };
      await TeacherService.updateTeacherStudent(payload.teacher_uuid,payload.student_uuid,payload);
      await this.GET_TEACHER_STUDENTS();
    },
    async addStudentToTeacher(params) {
      const payload = await {
        student_uuid: params.item.uuid,
        teacher_uuid: this.$route.params.id,
      };
      await TeacherService.addTeacherStudent(payload);
      await this.scrollTo("teacher-students-alert");
      await this.flashSuccess();
      await this.GET_TEACHER_STUDENTS();
    },
    async deleteTeacherStudent(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this student from this teacher?"
      );
      if (confirmDelete) {
        await TeacherService.deleteTeacherStudent(params);
        await this.GET_TEACHER_STUDENTS();
      }
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      getGeo: "searches/getGeo",
      getStudentSearchResults: "searches/getStudentSearchResults",
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    studentsTable: {
      get() {
        return this.$store.state.teachers.teacherStudents;
      },
    },
    cleanedSearchResults() {
      const data = this.getStudentSearchResults.map((k) => ({
        id: k.id,
        student_name: `${k.first_name} ${k.middle_name} ${k.last_name}`,
        dob: k.dob,
        sex: k.sex,
        district: k.district,
        village: k.village,
      }));
      return data;
    },
    teacherStudents: {
      get() {
        return this.$store.state.teachers.teacherStudents;
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.teacherStudentsFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.GET_TEACHER_STUDENTS();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}
</style>
